import { PaxTypeTitles } from './trip/TripModuleTypes';
import { type FreeService, type OptionalService } from './types';
import { BuyExtraFields, type PassengerFields } from '@store/form';
import { type PaxType } from '@utils/types';

export default class PassengerForm {
    public readonly defaultFields: PassengerFields;
    public readonly iranianExtraFields: PassengerFields;
    public readonly foreignerExtraFields: PassengerFields;
    public readonly buyExtraFields: BuyExtraFields;
    public readonly type: PaxType;
    public readonly title: string;
    /**
     * some optional service for choose in form
     *
     * @type {OptionalService[]}
     * @memberof PassengerForm
     */
    public readonly optionalServiceList: OptionalService[] = [];
    public readonly freeServiceList: FreeService[] = [];
    public subTitle?: string;
    public metadata?: any;
    public foreignerMessages?: string[];
    public readonly ageLimit = {
        adult: 12,
        child: 2,
    };

    constructor({
        defaultFields,
        iranianExtraFields,
        foreignerExtraFields,
        buyExtraFields = BuyExtraFields.None,
        type,
        title = PaxTypeTitles[type],
        subTitle,
        optionalServiceList = [],
        freeServiceList = [],
        foreignerMessages,
        ageLimit,
    }: {
        defaultFields: PassengerFields;
        iranianExtraFields: PassengerFields;
        foreignerExtraFields: PassengerFields;
        buyExtraFields?: BuyExtraFields;
        type: PaxType;
        title: string;
        subTitle?: string;
        optionalServiceList?: OptionalService[];
        freeServiceList?: FreeService[];
        foreignerMessages?: string[];
        ageLimit?: {
            adult: number;
            child: number;
        };
    }) {
        this.ageLimit = ageLimit ?? this.ageLimit;
        this.defaultFields = defaultFields;
        this.iranianExtraFields = iranianExtraFields;
        this.foreignerExtraFields = foreignerExtraFields;
        this.buyExtraFields = buyExtraFields;
        this.type = type;
        this.title = title;
        this.subTitle = subTitle;
        this.optionalServiceList = optionalServiceList;
        this.freeServiceList = freeServiceList;
        this.foreignerMessages = foreignerMessages;
    }

    mergeFields(other: PassengerForm) {
        return new PassengerForm({
            defaultFields: this.defaultFields | other.defaultFields,
            iranianExtraFields:
                this.iranianExtraFields | other.iranianExtraFields,
            foreignerExtraFields:
                this.foreignerExtraFields | other.foreignerExtraFields,
            buyExtraFields: this.buyExtraFields | other.buyExtraFields,
            type: this.type,
            title: this.title.includes(other.title)
                ? this.title
                : `${this.title} و ${other.title}`,
            subTitle: this.subTitle || other.subTitle,
            optionalServiceList: [
                ...this.optionalServiceList,
                ...other.optionalServiceList,
            ],
            freeServiceList: [
                ...this.freeServiceList,
                ...other.freeServiceList,
            ],
            foreignerMessages: [
                ...(this.foreignerMessages ?? []),
                ...(other.foreignerMessages ?? []),
            ],
            ageLimit: this.ageLimit || other.ageLimit,
        });
    }

    clone(): PassengerForm {
        return new PassengerForm({
            defaultFields: this.defaultFields,
            iranianExtraFields: this.iranianExtraFields,
            foreignerExtraFields: this.foreignerExtraFields,
            buyExtraFields: this.buyExtraFields,
            type: this.type,
            title: this.title,
            subTitle: this.subTitle,
            optionalServiceList: this.optionalServiceList.map(s => ({ ...s })),
            freeServiceList: this.freeServiceList.map(s => ({ ...s })),
            foreignerMessages: this.foreignerMessages,
            ageLimit: this.ageLimit,
        });
    }
}
